export default {
    congratulation: 'ยินดีด้วย',
    close: 'ปิด'
}
